import { useMemo } from 'react';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { FEATURE_FLAGS } from 'common/constants';

/** Sync subset of DFD client readiness: `checkAvailability()` also needs auth token when logged in. */
function isDfdEnvConfigured(): boolean {
  return Boolean(
    import.meta.env.VITE_DFD_HOST_URL && import.meta.env.VITE_DFD_ID,
  );
}

/**
 * Floating CTA only renders inside pages that mount `<LiveChat />` (home, care-services); no pathname check needed.
 * - Flag: `config_telus_alberta_live_chat_enabled`.
 * - Env: hide bubble if DFD URL/id missing (full gate is async `checkAvailability()` on START_CHAT).
 */
export function useLiveChatFloatingBubbleEnabled(): boolean {
  const { data: isLiveChatFlagOn } = useFeatureFlagQuery(
    FEATURE_FLAGS.TELUS_ALBERTA_LIVE_CHAT_ENABLED,
  );

  return useMemo(
    () => Boolean(isDfdEnvConfigured() && isLiveChatFlagOn === true),
    [isLiveChatFlagOn],
  );
}
